import { Injectable } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private toastr: ToastrService) {}

  showSuccess(message, title = '') {
    this.toastr.clear();
    this.toastr.success(message, title,{positionClass:"toast-bottom-right"});
  }
  showAlert(message, title = 'Alert') {
    this.toastr.clear();
    this.toastr.info(message, title, {
      disableTimeOut: true,
      closeButton: true,
      titleClass: 'alert-title',
      toastClass: 'alert-toast',
      positionClass: 'toast-center-center',
      messageClass: 'alert-message',
    });
  }
  showError(message, title = '') {
    if (this.toastr.currentlyActive == 0) this.toastr.error(message, title);
  }

  showInfo(message, title = '') {
    if (this.toastr.currentlyActive == 0) this.toastr.info(message, title);
  }

  showWarning(message, title = '') {
    if (this.toastr.currentlyActive == 0) this.toastr.warning(message, title);
  }
}
